<template>
    <div class="container">
        <md-dialog :md-active.sync="modEditarCentroCostos" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <!-- <pre>{{ infoCentroCostos }}</pre> -->
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoCentroCostos.codigo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoCentroCostos.descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.centro_costo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoCentroCostos.centro_costo" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="7" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <md-button class="md-primary" @click="editarCentroCostos">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteCentroCosto" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"></InacticaItem>
    </div>
</template>

<script>
import CentroCostos from '../../../services/CentroCostos'
import InacticaItem from '../../utils/InacticaItem.vue'
export default {
    name : 'Editar',
    props: ['modEditarCentroCostos','infoCentroCostos'],
    components : {InacticaItem},
    data: () => ({
        codigo : '',
        descripcion : '',
        centro_costo : '',
        deleteCentroCosto : false,
        idCentroCosto : null
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Editar centro de costos',
                    save : 'Guardar',
                    close : 'Cerrar',
                    delete : 'Eliminar',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    centro_costo : 'Centro de Costo',
                }
            }else{
                return {
                    title : 'Edit cost center',
                    save : 'Save',
                    close : 'Close',
                    delete : 'Delete',
                    codigo : 'Code',
                    descripcion : 'Description',
                    centro_costo : 'Centro de Costo',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        cierraModalDelet(){
            this.deleteCentroCosto = false
        },
        editarCentroCostos(){
            const dataForm = [
                this.infoCentroCostos.codigo,
                this.infoCentroCostos.descripcion,
                this.infoCentroCostos.centro_costo
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                let info = {
                    'id' : this.infoCentroCostos.id,
                    'codigo' : this.infoCentroCostos.codigo,
                    'descripcion' : this.infoCentroCostos.descripcion,
                    'centro_costo' : this.infoCentroCostos.centro_costo,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);
                CentroCostos.updateCentroCostosById(info)
                .then((res) => {
                    console.log(res.data);
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location.reload()
                    }
                })
                .catch((err) => {
                    if(err.response.status == 409){
                        this.$toast.error(err.response.data.message)
                    }else if(err.response.status == 500){
                        this.$toast.error(err.response.data.message)
                    }else{
                        this.$toast.error("Algo pasó, intentalo de nuevo")
                    }
                })
            }
        },
        eliminaRegistro(){
            this.idCentroCosto = this.infoCentroCostos.id
            this.deleteCentroCosto = true
        },
        confirmInactivate(){

            CentroCostos.deleteCentroCostos(this.idCentroCosto)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()                
                }
            })
            .catch((error) => error)
        }
    },
}
</script>

<style>

</style>
